var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CenterBottomContainer"},[_c('ContentTop',{attrs:{"title":"协会进入百姓健身房的开课服务人次排行","type":3}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"21px"}},[_c('rank-list',{attrs:{"listHeight":208,"tableTitle":_vm.tableTitle,"list":_vm.areaData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }